import {
  ParagraphText,
  ImageMessage,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import errorImg from 'assets/error.svg';
import { BaseModalContainer } from 'components/modals/common/base-modal.component';
import { ModalActionButton } from './common/modal-action-button.component';

interface AccountDeletedModalProps {
  onClose: () => void;
}

export const AccountDeletedModal = ({ onClose }: AccountDeletedModalProps) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.only('mobile'));

  return (
    <BaseModalContainer
      footer={
        <ModalActionButton
          actionType="submit"
          labelId="STR_I_UNDERSTAND"
          isMobile={isMobile}
          onClick={onClose}
          cssStyle={{
            background: '$interactiveActionPrimary',
            alignSelf: 'flex-end',
            marginBlockStart: '$two',
            '&:hover, &:active, &:focus': {
              backgroundColor: '$interactiveBackgroundHovered',
              color: '$interactiveActionHovered',
              textDecoration: 'none',
            },
          }}
        />
      }
      title={formatMessage({ id: 'STR_ACCOUNT_DELETED_TITLE' })}
      onClose={onClose}
    >
      <ImageMessage
        image={errorImg}
        css={{ flexGrow: 1, padding: '$two $none' }}
      >
        <ParagraphText>
          {formatMessage({ id: 'STR_ACCOUNT_DELETED_BODY_1' })}
        </ParagraphText>
        <ParagraphText>
          {formatMessage({ id: 'STR_ACCOUNT_DELETED_BODY_2' })}
        </ParagraphText>
      </ImageMessage>
    </BaseModalContainer>
  );
};
